export enum TableStatusType {
  Green = 'label--green',
  Orange = 'label--orange',
  Yellow = 'label--yellow'
}